import { IPerfectScrollStatus } from "../scroll/perfectScrollModel";

export const customScrollStateAT = Object.freeze({
    set: "set/customScrollState",
});

export const customScrollStatusReducer = (
    state = { innerChangeTick: 0 },
    { type, data }
) => (type !== customScrollStateAT.set ? state : { ...state, ...data });

export const setCustomScrollStatusAction = (
    data: Partial<IPerfectScrollStatus>
) => ({
    type: customScrollStateAT.set,
    data,
});
